<script>
import GraphBuilder from '@/components/Common/GraphBuilder.vue';
import { mapState, mapMutations } from 'vuex';
import {
  VIEW_GROK_TAB_KEY,
  VIEW_SAVED_SEARCHES_TAB_KEY,
} from '@/components/Log/log.constants';
import applicationGraphs from '@/utils/templates/logTemplates/application.graphs.config';

export default {
  name: 'LogGraph',
  components: {
    GraphBuilder,
  },
  data() {
    return {
      serviceId: '',
    };
  },
  computed: {
    ...mapState('globalState/app', ['chartsTemplate', 'openMenu']),
    getSourceId() {
      return this.$route.query.source
        ? this.$route.query.source?.split(',')[0]
        : '';
    },
    showGraphComp() {
      return (
        this.$route.query.currView !== VIEW_GROK_TAB_KEY &&
        this.$route.query.currView !== VIEW_SAVED_SEARCHES_TAB_KEY &&
        !(this.$route.query.queryExec?.length > 0)
      );
    },
    getChartConfig() {
      return applicationGraphs().barCharts;
    },
    customWidth() {
      return this.openMenu ? '63.25vw' : '75.25vw';
    },
  },
  methods: {
    ...mapMutations('globalState/app', ['setUpdateDasboard']),
  },
  watch: {
    '$route.query.source': {
      immediate: true,
      handler() {
        this.serviceId = this.getSourceId;
        this.setUpdateDasboard(this.serviceId);
      },
    },
  },
};
</script>

<template>
  <transition name="view" appear>
    <div class="wrapper" v-if="getChartConfig && showGraphComp">
      <div
        class="chart-element"
        v-for="(chartConfig, index) in getChartConfig"
        :key="'bar' + index"
      >
        <GraphBuilder
          :chartConfig="chartConfig"
          :index="index"
          :layoutIndex="0"
          :serviceId="serviceId"
        />
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.wrapper {
  @include flex-row-wrap;
  width: v-bind(customWidth);
}

.chart-element {
  width: 100%;
  margin-bottom: 1.35em;
}

:deep(.chart-body) {
  height: 12em;
  width: 100%;
}

:deep(.chart-box) {
  height: 14.375em;
  width: 100%;
  border-radius: 0.25rem;
}
:deep(.bar-header) {
  border-bottom: none;
  padding-top: 0.8rem;
}
</style>
